const TRANSLATES = {
  LANGUAGES: ['pl', 'en', 'ar'],
};
export default TRANSLATES;
